import API from "./api";

export const getPublicBlogs = async () => {
  const res = await API.get("/public/blogs");
  return res.data;
};
export const getPublicJobs = async () => {
  const res = await API.get("/public/jobs");
  return res.data;
};
export const getPublicJobById = async (id) => {
  const res = await API.get(`/public/jobs/${id}`);
  return res.data;
};

export const validatePublicOfferLetter = async ({ candidateId, email }) => {
  const res = await API.post("/public/offer/validate", {
    candidateId,
    email,
  });

  return res.data;
};

export const createPublicComplaint = async ({
  name,
  email,
  phone,
  subject,
  description,
}) => {
  const res = await API.post("/public/complaint", {
    name,
    email,
    phone, // ✅ THIS FIXES EVERYTHING
    subject,
    description,
  });

  return res.data;
};